import React from "react";
import { Button } from "react-bootstrap";
import { useDrag } from "react-dnd";

import { Guest } from "../../api";

import "./DraggableGuest.css";

export interface DraggableGuestItem {
  guest: Guest;
}

interface DraggableGuestProps {
  guest: Guest;
  tableID?: string;
  onContextMenu?: (e: React.MouseEvent, guest: Guest) => void;
  handleRemoveGuest?: (guestID: string, tableID: string) => void;
  onClick?: (e: React.MouseEvent, guest: Guest) => void;
  isDuplicate?: boolean;
  isMobile?: boolean;
}

function DraggableGuest({
  guest,
  tableID,
  handleRemoveGuest,
  onContextMenu,
  onClick,
  isDuplicate,
  isMobile,
}: DraggableGuestProps) {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: "guest",
    item: { guest },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e, guest);
    }
  };

  return (
    <div
      ref={dragRef}
      key={guest.guest_id}
      className="list-item"
      style={{ opacity: isDragging ? 0.5 : 1 }}
      onContextMenu={(e) =>
        onContextMenu ? onContextMenu(e, guest) : undefined
      }
      onClick={handleClick}
    >
      <div className="list-name">{guest.guest_name}</div>
      {isDuplicate && <span className="duplicate-icon" title="Duplicate guest name">!</span>}
      <div className="list-count">{guest.guest_count}P.</div>
      {handleRemoveGuest && (
        <Button
          variant="dangerous"
          className="remove-guest-btn"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveGuest(guest.guest_id, tableID || "");
          }}
        >
          <i className="fa fa-times"></i>
        </Button>
      )}
    </div>
  );
}

export default DraggableGuest;
